import React from "react";
import { FaAward, FaGlobeAsia, FaStar } from "react-icons/fa";

const FOOTER_ITEMS = [
  {
    icon: FaAward,
    title: "Trusted & Transparent",
    text: "Verified & trusted by thousands of experts",
  },
  {
    icon: FaStar,
    title: "User Loved Platform",
    text: "High ratings & happy customers",
  },
  {
    icon: FaGlobeAsia,
    title: "Made in India",
    text: "Built for astrologers, by AstroCall",
  },
];

function ZodiacDecoration() {
  const signs = ["♈", "♉", "♊", "♋", "♌", "♍", "♎", "♏", "♐", "♑", "♒", "♓"];
  return (
    <svg
      className="ao-bg__wheel-svg"
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="200" cy="200" r="190" stroke="currentColor" strokeWidth="0.6" />
      <circle cx="200" cy="200" r="150" stroke="currentColor" strokeWidth="0.5" />
      <circle cx="200" cy="200" r="110" stroke="currentColor" strokeWidth="0.4" />
      {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        const x1 = 200 + 70 * Math.cos(rad);
        const y1 = 200 + 70 * Math.sin(rad);
        const x2 = 200 + 190 * Math.cos(rad);
        const y2 = 200 + 190 * Math.sin(rad);
        const sx = 200 + 168 * Math.cos(rad);
        const sy = 200 + 168 * Math.sin(rad);
        return (
          <g key={deg}>
            <line
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke="currentColor"
              strokeWidth="0.4"
              opacity="0.5"
            />
            <text
              x={sx}
              y={sy}
              fill="currentColor"
              fontSize="11"
              textAnchor="middle"
              dominantBaseline="middle"
              opacity="0.55"
            >
              {signs[i]}
            </text>
          </g>
        );
      })}
    </svg>
  );
}

export default function AstrologerOnboardingLayout({ marketing, formCard, modal, longForm = false }) {
  return (
    <div className={`ao-page${longForm ? " ao-page--long" : ""}`}>
      <div className="ao-bg" aria-hidden>
        <div className="ao-bg__glow" />
        <div className="ao-bg__wheel ao-bg__wheel--left">
          <ZodiacDecoration />
        </div>
        <div className="ao-bg__wheel ao-bg__wheel--right">
          <ZodiacDecoration />
        </div>
        <div className="ao-bg__card-glow" />
      </div>

      <div className="ao-shell">
        <div className="ao-main">
          {marketing}
          <div className="ao-form-col">{formCard}</div>
        </div>

        {!longForm && (
          <footer className="ao-trust-bar" aria-label="Trust signals">
            {FOOTER_ITEMS.map(({ icon: Icon, title, text }) => (
              <div key={title} className="ao-trust-bar__item">
                <span className="ao-trust-bar__icon">
                  <Icon size={22} aria-hidden />
                </span>
                <div>
                  <p className="ao-trust-bar__title">{title}</p>
                  <p className="ao-trust-bar__text">{text}</p>
                </div>
              </div>
            ))}
          </footer>
        )}
      </div>

      {modal}
    </div>
  );
}
